import React from "react";
import { AttachmentItem } from ".";
import { FileProcessingStatus, IAttachmentFile } from "..";
import { AttachmentListItemsDiv, AttachmentListItemsUL } from "./AttachmentListItems.styles";

export interface IAttachmentListItemsProps {
    Attachments: IAttachmentFile[];
    OnRemoveAttachment?: (file: IAttachmentFile) => void;
}

export const AttachmentListItems = ({ Attachments, OnRemoveAttachment }: IAttachmentListItemsProps) => {

    if (Attachments?.length) {

        const attachmentsProcessing = Attachments.filter((att) => [FileProcessingStatus.Uploaded, FileProcessingStatus.Deleted].indexOf(att.ProcessingStatus) === -1);

        return (
            <AttachmentListItemsDiv>
                <AttachmentListItemsUL>
                    {
                        Attachments
                            .filter((attachment) => attachment.ProcessingStatus !== FileProcessingStatus.Deleted)
                            .map((attachment) => {
                                return <AttachmentItem key={attachment.File.name} Attachment={attachment} OnRemoveAttachment={OnRemoveAttachment} Disabled={attachmentsProcessing.length > 0} />;
                            })
                    }
                </AttachmentListItemsUL>
            </AttachmentListItemsDiv>
        );
    }

    return null;
};
